import styles from './app.module.css';
import './app.css'
import Home from './modules/home';
import Fq from './modules/fq';
import { useWindowSize } from './hooks/useWindowSize';

function App() {
	const { width } = useWindowSize()
	return (
		<div className={styles.appContainer}>
			{
				width > 1200 ? <Home /> : null
			}
			<Fq />
		</div>
	);
}

export default App;
